export interface InfiniteResponse<T> {
  items: T[];
  total: {
    all: number;
    filtered: number;
  };
}

export const useManageInfiniteScroll = <T>(data: InfiniteResponse<T>[]) => {
  const anyDataExists = data?.length > 0;

  const infiniteData = anyDataExists ? data?.map((d) => d?.items).flat() : [];

  const totalElementsNumber = anyDataExists ? data[0]?.total?.filtered : 0;

  const anyElementsToFetch = totalElementsNumber > infiniteData.length;

  return { infiniteData, anyElementsToFetch };
};
